<template>
    <div>
      <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
      <ExperiencesForm @submit-requested="submitRequested"></ExperiencesForm>
    </div>
  </template>
   
  <script>
  import { mapActions } from 'vuex'
  import ExperiencesForm from '../forms/FormExperiences.vue'
  
  export default {
    components: { ExperiencesForm },
    methods: {
      ...mapActions('experiences', ['postExperience']),
      submitRequested (input) {
        this.postExperience(input);
      },
    }
  }
  </script> 
   
  <style scoped>
  thead > tr > th
  {
    text-align: unset !important;
  }
  </style>
  